import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import Button from "components/button/Button";
import useAuth from "hooks/auth/useAuth";
import logo from "../../public/logo.svg";

const firstList = [
  {
    title: "Գլխավոր",
    value: "/",
  },
  { title: "Կանխատեսողներ", value: "/contact-us" },
  { title: "Կանխատեսումներ", value: "/mission" },
  { title: "Ընդհանրական", value: "/our-work" },
];

const secondList = [
  { title: "Կապ", value: "/contact" },
  { title: "Մեր մասին", value: "/about-us" },
  { title: "Հարցեր և պատասխաններ", value: "/questions" },
  { title: "Օգտագործման պայմաններ", value: "/terms-of-use" },
  { title: "Գաղտնիության Քաղաքականություն", value: "/privacy-policy" },
];

const Footer = ({ currentUser }) => {
  const { isLoading, signOut } = useAuth();
  const router = useRouter();
  console.log(router.pathname.includes("auth"));
  return (
    <div className="flex xl:flex-row md-gap-0 gap-4 flex-col justify-between items-start bg-white px-[20px] xl:px-[124px] py-6 border">
      <div className="flex flex-col gap-[12px] w-full xl:w-[224px] pl-4 xl:pl-0">
        {!router.pathname.includes("auth") && (
          <Link href="/" className="flex gap-4 items-center cursor-pointer">
            <Image
              width={0}
              height={0}
              sizes="100vh"
              src={logo}
              alt="logo"
              priority
            />
          </Link>
        )}
        <span className="">
          Սույն կայքում տեղ գտած հրապարակումների հեղինակային իրավունքը պատկանում
          է բացառապես prognos.am ին
        </span>
      </div>
      <div className="flex flex-col">
        {firstList.map((page, index) => (
          <Link
            key={page.value || index}
            className={`bg-white px-4 text-[14px] ${!page?.value && "text-[#0033FF] text-[20px] font-bold"} py-2 rounded-md ${page?.value && "font-medium cursor-pointer hover:bg-[#0033FF] hover:text-white transition-all duration-500"}`}
            href={page.value || ""}
          >
            {page.title}
          </Link>
        ))}
      </div>
      <div className="flex flex-col">
        {secondList.map((page, index) => (
          <Link
            key={page.value || index}
            href={page.value || ""}
            className={`bg-white px-4 text-[14px] ${!page?.value && "text-[#0033FF] text-[20px] font-bold"} py-2 rounded-md ${page?.value && "font-medium cursor-pointer hover:bg-[#0033FF] hover:text-white transition-all duration-500"}`}
          >
            {page.title}
          </Link>
        ))}
      </div>
      {!router.pathname.includes("auth") && !isLoading && !currentUser && (
        <div className="flex items-center gap-4">
          <Button
            onClick={() =>
              router.push(
                {
                  pathname: "/auth",
                  query: { mode: "registration" },
                },
                undefined,
                { shallow: true },
              )
            }
            variant="secondary"
          >
            <span className="text-[14px]">Գրանցվել</span>
          </Button>
          <Button
            onClick={() =>
              router.push(
                {
                  pathname: "/auth",
                  query: { mode: "login" },
                },
                undefined,
                { shallow: true },
              )
            }
          >
            Մուտք
          </Button>
        </div>
      )}
      {!isLoading && currentUser && (
        <div>
          <Button onClick={signOut}>Դուրս գալ</Button>
        </div>
      )}
    </div>
  );
};

export default Footer;
